/* eslint-disable react/no-danger */
import React from 'react';
import _ from 'lodash';
import { motion } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/bundle';

function HomeVideoBannerSlider({ id, data }) {
  const items = _.get(data, 'items', []).map((item) => item.content);

  const scrollToElement = () => {
    const targetElement = document.getElementById('dwtcFreeZoneTwoColTitleText_2');
    let offset = targetElement.offsetTop;

    if (window.innerWidth > 768) {
      offset = targetElement.offsetTop - 150;
    }

    if (targetElement) {
      window.scrollTo({ top: offset, behavior: 'smooth' });
    }
  };

  return (
    <section id={id} 
    className="h-[380px] md:h-[500px] xl:h-auto lg:aspect-[1920/796] relative z-[90]">
      {items.length > 1 ? (
        <Swiper slidesPerView={1} className="!h-full">
          {_.map(items, (item, index) => (
            <SwiperSlide className="relative" key={index}>
              <div
                className="max-w-[1200px] px-4 w-full absolute z-[9999] top-1/2 left-1/2 
              -translate-x-1/2 -translate-y-1/2 flex flex-col gap-y-[30px]">
                <motion.div
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: 0.3 }}
                  viewport={{ once: true }}
                  className="pt-5 md:pt-0 text-clamp20to60 text-center 
                child:!text-white child:leading-1.2
                h1-child:ltr:font-URWDINMedium 
                h1-child:rtl:font-GESSTwoDWTCMedium
                h1-strong:ltr:font-URWDINBold 
                h1-strong:rtl:font-GESSTwoDWTCMedium 
                h1-strong-br:hidden
                h1-strong-br:md:block"
                  dangerouslySetInnerHTML={{ __html: item.title }}
                />
                <motion.div
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: 0.4 }}
                  viewport={{ once: true }}
                  className="text-clamp10to20 text-center child:!text-white child:leading-[1.6]
                child:m-0 child:font-LibreBaskervilleRegular"
                  dangerouslySetInnerHTML={{ __html: item.text }}
                />
              </div>
              <div className="absolute inset-0 w-full !h-full bg-[#1a1a1a] bg-opacity-60 z-20" />
              <div
                className="relative top-0 left-0 w-full !h-full -z-10 pointer-events-none
              overflow-hidden">
                {item.videUrl.includes('.mp4') ? (
                  <>
                    <video
                      playsInline
                      loop
                      muted
                      autoPlay
                      preload="true"
                      className="hidden md:block pointer-events-none absolute bottom-0
                border-none outline-none object-cover
                h-[56.25vw] min-h-screen !min-w-[177.77vh] md:w-screen top-1/2 left-1/2
                -translate-x-1/2 -translate-y-1/2">
                      <source src={item.videUrl} type="video/mp4" />
                    </video>
                    <video
                      playsInline
                      loop
                      muted
                      autoPlay
                      preload="true"
                      className="md:hidden pointer-events-none absolute bottom-0
                border-none outline-none object-cover aspect-[320/320] h-full w-screen 
                top-1/2 left-1/2
                -translate-x-1/2 -translate-y-1/2">
                      <source src={item.mobileVideoUrl} type="video/mp4" />
                    </video>
                  </>
                ) : (
                  <iframe
                    className="pointer-events-none absolute bottom-0
                border-none outline-none
                h-[56.25vw] md:h-full w-auto top-1/2 left-1/2
                -translate-x-1/2 -translate-y-1/2"
                    src={item.videUrl}
                    title={item.title}
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    webkitallowfullscreen="true"
                    mozallowfullscreen="true"
                    allowFullScreen
                  />
                )}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <div className="!h-full">
          <div className="relative h-full">
            <div
              className="max-w-[1200px] px-4 w-full absolute z-[9999] top-1/2 left-1/2 
              -translate-x-1/2 -translate-y-1/2 flex flex-col gap-y-[30px]">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: 0.3 }}
                viewport={{ once: true }}
                className="pt-5 md:pt-0 text-clamp20to60 text-center 
                child:!text-white child:leading-1.2
                h1-child:ltr:font-URWDINMedium 
                h1-child:rtl:font-GESSTwoDWTCMedium
                h1-strong:ltr:font-URWDINBold 
                h1-strong:rtl:font-GESSTwoDWTCMedium 
                h1-strong-br:hidden
                h1-strong-br:md:block"
                dangerouslySetInnerHTML={{ __html: items[0].title }}
              />
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: 0.4 }}
                viewport={{ once: true }}
                className="text-clamp10to20 text-center child:!text-white child:leading-[1.6]
                child:m-0 child:font-LibreBaskervilleRegular"
                dangerouslySetInnerHTML={{ __html: items[0].text }}
              />
            </div>
            <div className="absolute inset-0 w-full !h-full bg-[#1a1a1a] bg-opacity-60 z-20" />
            <div
              className="relative top-0 left-0 w-full !h-full -z-10 pointer-events-none
              overflow-hidden">
              {items[0].videUrl.includes('.mp4') ? (
                <>
                  <video
                    playsInline
                    loop
                    muted
                    autoPlay
                    preload="true"
                    className="hidden md:block pointer-events-none absolute bottom-0
                border-none outline-none object-cover
                h-[56.25vw] min-h-screen !min-w-[177.77vh] md:w-screen top-1/2 left-1/2
                -translate-x-1/2 -translate-y-1/2">
                    <source src={items[0].videUrl} type="video/mp4" />
                  </video>
                  <video
                    playsInline
                    loop
                    muted
                    autoPlay
                    preload="true"
                    className="md:hidden pointer-events-none absolute bottom-0
                border-none outline-none object-cover aspect-[320/320] h-full w-screen 
                top-1/2 left-1/2
                -translate-x-1/2 -translate-y-1/2">
                    <source src={items[0].mobileVideoUrl} type="video/mp4" />
                  </video>
                </>
              ) : (
                <iframe
                  className="pointer-events-none absolute border-none outline-none 
                  min-h-[380px] h-[56.25vw] w-[275%] md:h-[66vw] md:w-[168%] 
                  lg:h-inherit lg:w-[107%] top-1/2 left-1/2
                -translate-x-1/2 -translate-y-1/2"
                  src={items[0].videUrl}
                  title={items[0].title}
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  webkitallowfullscreen="true"
                  mozallowfullscreen="true"
                  allowFullScreen
                />
              )}
            </div>
          </div>
        </div>
      )}

      <button
        type="button"
        onClick={scrollToElement}
        className="absolute z-10 bottom-4 md:bottom-8 lg:bottom-11 -translate-x-1/2 left-1/2 
      p-3 border-0 bg-transparent">
        <svg
          className="w-[16px] md:w-[22px] h-[12px]"
          viewBox="0 0 22 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M1 1L11 11L21 1"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </section>
  );
}

export default HomeVideoBannerSlider;